import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from 'api';

const generalExtraActions = {
  getUsers: createAsyncThunk('general/getUsers', api.getUsers),
  getCities: createAsyncThunk('general/getCities', api.getCities),
  getSubRoles: createAsyncThunk('general/getSubRoles', api.getSubRoles),
  getSubRolesByRole: createAsyncThunk('general/getSubRolesByRole', api.getSubRolesByRole),
  getGrounds: createAsyncThunk('general/getGrounds', api.getGrounds),
  getSports: createAsyncThunk('general/getSports', api.getSports),
  getAmenities: createAsyncThunk('general/getAmenities', api.getAmenities),
  getFields: createAsyncThunk('general/getSlots', api.getFields),
  getBookings: createAsyncThunk('general/getBookings', api.getBookings),
  getReports: createAsyncThunk('general/getReports', api.getReports),
  getReportDetail: createAsyncThunk('general/getReportDetail', api.getReportDetail),
  resolveReport: createAsyncThunk('general/resolveReport', api.resolveReport),
  dismissReport: createAsyncThunk('general/dismissReport', api.dismissReport),
  markReportUnderReview: createAsyncThunk('general/markReportUnderReview', api.markReportUnderReview),
  fetchNotifications: createAsyncThunk('general/fetchNotifications', api.getNotifications),
  getNotificationDetail: createAsyncThunk('general/getNotificationDetail', api.getNotificationDetail),
  markNotificationsRead: createAsyncThunk('general/markNotificationsRead', api.markNotificationsRead),
  markAllNotificationsRead: createAsyncThunk('general/markAllNotificationsRead', api.markAllNotificationsRead),
  getUnreadNotificationCount: createAsyncThunk('general/getUnreadNotificationCount', api.getUnreadNotificationCount),
};

export default generalExtraActions;
